// extracted by mini-css-extract-plugin
export default {"MainPage__Sections":"MainPage_MainPage__Sections__DKbpp","MainPage__Separator":"MainPage_MainPage__Separator__g7p7c"};